<nav class="breadcrumb" aria-label="Breadcrumb">
  <ng-container *ngIf="vm.page; else parentOnly">
    <span class="breadcrumb__prefix">
      <a class="breadcrumb__link" [routerLink]="dashboardPath">{{ dashboardsLabel }}</a>
      <mat-icon class="breadcrumb__separator" aria-hidden="true">chevron_right</mat-icon>
    </span>
    <span class="breadcrumb__current" aria-current="page">{{ vm.page.title }}</span>
  </ng-container>
  <ng-template #parentOnly>
    <span class="breadcrumb__current" aria-current="page">{{ dashboardsLabel }}</span>
  </ng-template>
</nav>
